import { useMemo, type PropsWithChildren } from 'react';
import { blueGrey } from '@mui/material/colors';
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
import { MuiDialogStyles } from './MuiDialogStyles';

export const KanbanThemeProvider = ({ children }: PropsWithChildren) => {
  const appTheme = useTheme();

  const kanbanTheme = useMemo(() => {
    const mode = appTheme.palette.mode ?? 'light';

    return createTheme(appTheme, {
      palette: {
        mode,
        primary: blueGrey,
      },
      components: MuiDialogStyles,
    });
  }, [appTheme]);

  return <ThemeProvider theme={kanbanTheme}>{children}</ThemeProvider>;
};
